<template>
  <div class="container particle-network-animation">
    <header style="text-align: left;padding-left: 3%;padding-top: 2%;">
<!--      <h2 style="font-size: 25px;color: white;">龙游县公共资源交易网</h2>-->
    </header>
    <section>
      <div class="center">
        <ul class="centerLeft">
          <li class="bg-box"></li>
          <li class="logo1 bubble"><i></i></li>
          <li class="logo2 bubble"><i></i></li>
          <li class="logo3 bubble"><i></i></li>
          <li class="logo4 bubble"><i></i></li>
          <li class="logo5 bubble"><i></i></li>
          <li class="fly"><i></i></li>
        </ul>
        <div class="centerRight">
          <p><span v-for="(item,index) in loginTypeList" :key="item"
                   :class="spanActive == index ? 'spanActive' : ''" @click="changeLock(index)">{{ item }}</span></p>
          <div class="caLock" v-if="lockActive===2">
            <div class="lockImg">
              <img src="../../../../assets/img/lock.png" alt="">
            </div>
            <el-button @click="CALogin" class="login-btn" style="padding: 0px 0px;" type="primary">
              登录
            </el-button>
            <li style="margin-top: 10px;">
              <span style="display: inline-block;line-height: 40px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <p @click="getBound" style="font-size: 14px;cursor: pointer;margin-top: 10px;" class="pull-right">
                CA绑定>></p>
            </li>
          </div>
          <div class="login-box" v-else-if="lockActive===1">
            <div class="login-form" v-if="LoginFormVisible">
              <el-form  :model="dataForm" :rules="dataRule" ref="dataForm" :hide-required-asterisk="false"
                       @keyup.enter.native="dataFormSubmit()"
                       :status-icon="false">
                <ul class="login-ul">
                  <li class="login-li">
                    <!--                                        <i class="login-user"></i>-->
                    <el-form-item prop="userName" label="账号">
                      <el-input v-model="dataForm.userName" placeholder="请输入账号">
                        <i slot="prefix" class="el-input__icon el-icon-user" style="font-size:20px;"></i>
                      </el-input>
                    </el-form-item>
                  </li>
                  <li class="login-li">
                    <!--                                        <i class="login-pwd"></i>-->
                    <el-form-item prop="password" label="密码">
                      <el-input v-model="dataForm.password" type="password" placeholder="请输入密码">
                        <i slot="prefix" class="el-input__icon el-icon-lock" style="font-size:20px;"></i>
                      </el-input>
                    </el-form-item>
                  </li>
                  <li class="captcha-box">
                    <el-form-item prop="captcha">
                      <el-row :gutter="20">
                        <el-col :span="14">
                          <el-input v-model="dataForm.captcha" placeholder="验证码">
                          </el-input>
                        </el-col>
                        <el-col :span="10" class="login-captcha">
                          <img :src="captchaPath" @click="getCaptcha()" alt="">
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </li>
                  <li>
                    <el-form-item>
                      <el-button class="login-btn" style="padding: 0px 0px;"
                                 type="primary"
                                 @click="dataFormSubmit()">立即登录
                      </el-button>
                    </el-form-item>
                  </li>
<!--                  <li>-->
<!--                    <el-form-item>-->
<!--                      <el-button class="login-btn" style="padding: 0px 0px;"-->
<!--                                 type="primary"-->
<!--                                 @click="dingLogin">浙政钉扫码登录-->
<!--                      </el-button>-->
<!--                    </el-form-item>-->
<!--                  </li>-->
                  <!--                                    <li>-->
                  <!--                                        <a @click="goForget"><span style="cursor: pointer"-->
                  <!--                                                                   class="blue-back">忘记密码?</span></a>-->
                  <!--                                        <span style="display: inline-block;line-height: 40px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
                  <!--                                        <a :href="getRegisterUrl()" v-if="registerUrl" class="pull-right"-->
                  <!--                                           target="_blank"><span-->
                  <!--                                                class="blue-back">注册</span></a>-->
                  <!--                                    </li>-->
                </ul>
              </el-form>
<!--              <iframe v-else style="width: 100%;height: 100%;overflow: hidden" :src="loginUrl" frameborder="0"></iframe>-->
            </div>
            <div class="login-form" v-else>
              <p>欢迎登录</p>
              <el-form ref="dataForm" status-icon>
                <ul class="login-ul">
                  <li class="login-li" style="padding-top: 40px">
                    <el-form-item prop="userName" label="账号:">
                      <span>{{ userInfo.displayName }}</span>
                    </el-form-item>
                  </li>
                  <li>
                    <el-form-item>
                      <el-button class="login-btn" style="padding: 0px 0px;" type="primary"
                                 @click="loginByToken()">立即登录
                      </el-button>

                    </el-form-item>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="showLoginForm"><span
                        class="blue-back">切换账号</span></a>
                  </li>
                </ul>
              </el-form>
            </div>
          </div>
          <div class="login-box" v-else-if="lockActive===0" >
            <iframe  style="width: 100%;height: 100%;overflow: hidden" :src="loginUrl" frameborder="0"></iframe>
          </div>
        </div>
        <div>
          <el-dialog title="CA绑定" :visible.sync="dialogVisible" width="40%">
            <div>
              <el-form ref="form" label-width="150px" class="form">
                <el-form-item label="用户名" prop="password">
                  <el-input style="width: 300px;" v-model="CAData.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input type="password" style="width: 300px;"
                            v-model="CAData.password"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="captcha">
                  <el-input style="width: 170px;margin-right: 5px;" v-model="CAData.captcha">
                  </el-input>
                  <img :src="captchaPath" @click="getCaptcha()" alt="">
                </el-form-item>
                <!--                                <el-form-item label="口令" prop="password">-->
                <!--                                    <el-input type="password" style="width: 300px;" v-model="command"></el-input>-->
                <!--                                </el-form-item>-->
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button style="width: 100px;" type="primary" @click="boundSave">确 定</el-button>
                <el-button style="width: 100px;" @click="dialogVisible = false" class="backBtn">关闭</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {getUUID} from '@/utils'
import {isURL} from '@/utils/validate'
import {logoutWithoutRedirect} from '@/utils/login'
import {initCa, getCaInfo, SignData} from '@/plugins/pmca'
import axios from 'axios'
import '@/plugins/lizixiaoguo/js/jquery.min.js'
import '@/plugins/lizixiaoguo/css/style.css'
import ParticleNetworkAnimation from '@/plugins/lizixiaoguo/js/script.js'
import 'element-ui/lib/theme-chalk/index.css'
import Crypto from "@/utils/crypto";

let contextPath = window.SITE_CONFIG.contextPath
if (contextPath == undefined) {
  contextPath = ''
}
const ssoHttp = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  baseURL: contextPath,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=utf-8'
  }
})

export default {
  data() {
    return {
      command: '',
      dialogVisible: false,
      certPwd: true,
      bool: true,
      // 忘记密码
      showPass: false,
      inquire: {
        type: '1',
        code: '',
        captcha: ''
      },

      LoginFormVisible: true,
      authorizeCode: '',
      userInfo: {displayName: ''},
      registerUrl: '',
      loginTypeList: ['浙政钉登录','密码登录', '锁登录'],
      lockActive: 0,
      spanActive: 0,
      dataForm: {
        userName: '',
        password: '',
        uuid: '',
        captcha: ''
      },
      //ca绑定
      CAData: {
        username: '',
        password: '',
        captcha: '',
        caCode: '',
        friendlyName: '',
        expireDate: '',
        fromDate: '',
        remark: '',
      },
      //CA
      CAInfo: {
        loginType: 1,
        provider: '',
        tradeOrgId: '',
        signCert: '',
        signData: '',
        originData: '',
        caCode: '',
      },

      dataRule: {
        userName: [
          {required: true, message: '帐号不能为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '验证码不能为空', trigger: 'blur'}
        ]
      },
      appCode: '',
      backUrl: '',
      captchaPath: '',
      dingLoginShow: false,
      loginUrl:''
    }
  },
  mounted() {
    this.anTion()
    setInterval(this.anTion, 6000)
    ParticleNetworkAnimation()
    const that = this;
    window.addEventListener('message', function(event) {
      if (event.data.code && event.data.code != ''){
        that.$http.post(`/callback/zwdd/${that.$route.params.appCode}?code=${event.data.code}`).then(res => {
          if (res.data.code == 1){
            that.redirectToLogin(res.data.authCode)
          }else {
            that.$message.error(res.data.msg);
            location.reload();
          }
        })
      }
    });
  },
  created() {
    this.appCode = this.$route.params.appCode
    this.backUrl = this.$route.query.redirect_uri
    let logout = this.$route.query.logout
    let oauth = this.$route.query.oauth
    if (!isURL(this.backUrl)) {
      this.$router.push({name: 'authorize-error'})
      return
    }
    let type = this.$route.params.type
    if (oauth === 2 || oauth === '2') {
      type = 2
    }
    if (logout === "1") {
      this.LoginFormVisible = true
      let _self = this
      if (this.appCode !== '1') {
        //外部系统退出时，需要报基础平台也退出处理掉
        logoutWithoutRedirect(function (data) {
          _self.getCaptcha()
        })
      } else {
        this.getCaptcha()
      }
    } else if (type === 1 || type === '1') {
      this.LoginFormVisible = true
      this.getCaptcha()
    } else if (type === 2 || type === '2') {
      this.loadByCookie(true)
    } else {
      this.LoginFormVisible = true
      this.getCaptcha()
    }
    this.dingLogin();
    this.initRegisterUrl()
  },
  methods: {
    getRegisterUrl() {
      return this.registerUrl
    },
    dingLogin(){
      // this.dingLoginShow = true
      this.$http.post(`/ssoLoginUrl/zwdd/${window.SITE_CONFIG['appCode']}`).then(({data}) => {
        if(data.code==='1'){
          this.loginUrl = data.data
        }else{
          location.reload();
          // this.loginUrl =''
        }
        // this.loginUrl = data.data
        // this.loginUrl = `https://login.dg-work.cn/oauth2/auth.htm?response_type=code&client_id=LYSuite_dingoa&redirect_uri=http://183.129.186.86:18053/api/callback/zwdd/555DB7DAE20A4214B40955224065A901&scope=get_user_info&authType=QRCODE&embedMode=true`
      })
    },
    initRegisterUrl() {
      let url = '/sys/getConfig?key=ent_register_url'
      this.$http.post(url, {}).then(({data}) => {
        this.registerUrl = data.data
        // console.log(data, 'initRegisterUrl', this.registerUrl)
      })
    },
    showLoginForm() {
      this.LoginFormVisible = true
      this.getCaptcha()
    },
    changeLock(index) {
      this.spanActive = index;
      this.dingLoginShow = false
      if(this.spanActive=== 0){
        this.lockActive=0
        this.dingLogin();
      }else if(this.spanActive=== 1){
        this.lockActive=1
      }else if(this.spanActive=== 2){
        this.lockActive=2
      }
      // this.lockActive = this.spanActive === 0 ? true : false;
    },
    //动画
    anTion() {
      let shang = $('.bubble');
      let dou = $('.bubble i');
      shang.addClass('shangsheng')
      dou.addClass('doudong');
      setTimeout(function () {
        shang.removeClass('shangsheng');
        dou.removeClass('doudong');
      }, 3000)
    },
    //初始化CA
    CALogin() {
      initCa((isIE) => {
        if (!isIE) {
          this.$alert(
              "请使用ie10及以上浏览器",
              "提示",
              {confirmButtonText: "确定"}
          );
        }
      })
      getCaInfo((certInfo) => {
        this.CAInfo.provider = window.SITE_CONFIG['ca']
        this.CAInfo.signCert = certInfo.base64cert
        this.CAInfo.caCode = certInfo.certserial
        this.CAInfo.backUrl = ''
        this.CAInfo.appCode = this.appCode
        this.CAInfo.username = 'ca'
        this.CAInfo.password = 'ca'
      })
    },
    //获取ca绑定
    getBound() {
      initCa((isIE) => {
        if (!isIE) {
          this.$alert(
              "请使用ie10及以上浏览器",
              "提示",
              {confirmButtonText: "确定"}
          );
        }
      })
      getCaInfo((certInfo) => {
        this.CAInfo.provider = window.SITE_CONFIG['ca']
        this.CAInfo.signCert = certInfo.base64cert
        this.CAInfo.caCode = certInfo.certserial
        this.CAInfo.backUrl = ''
        this.CAInfo.appCode = this.appCode
        this.CAInfo.username = 'ca'
        this.CAInfo.password = 'ca'
      })
      this.dialogVisible = true
    },
    //ca绑定提交
    boundSave() {
      this.$http.post('/oauth/bidingCa', this.CAData).then(({data}) => {
        if (data && data.code === '1') {
          this.$message({
            message: 'CA绑定成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.dialogVisible = false
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //ca登录
    affirmCA() {
      this.CAInfo.signData = SignData()
      if (!this.CAInfo.signData) {
        this.$alert('请确认河南CA的UKEY是否正确插入', '提示', {
          confirmButtonText: '确定',
        });
        return
      }
      ssoHttp.post('/sso/oauth/login', this.CAInfo).then(({data}) => {
        if (data && data.code === '1') {
          this.redirectToLogin(data.authCode)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    goForget() {
      this.$router.push({
        path: '/forget/one'
      })
    },
    loginByToken() {
      this.redirectToLogin(this.authorizeCode)
    },
    loadByCookie(flag) {
      ssoHttp({
        url: '/sso/oauth/authorize',
        method: 'get'
      }).then(({data}) => {
        // eslint-disable-next-line no-console
        console.log(data, 'aa')
        if (data && data.code === "1") {
          this.authorizeCode = data.data
          this.LoginFormVisible = false
          this.userInfo = data.user
          if (flag === true) {
            this.redirectToLogin(this.authorizeCode)
          }
        } else {
          this.getCaptcha()
          this.LoginFormVisible = true
        }
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(`%c${e} 使用用户名密码登录！！`, 'color:blue')
        this.getCaptcha()
        this.LoginFormVisible = true
      })
    },
    redirectToLogin(token) {
      let redirectUrl = this.backUrl
      if (redirectUrl.indexOf('?') >= 0) {
        redirectUrl += '&token=' + token;
      } else {
        redirectUrl += '?token=' + token;
      }
      location.href = redirectUrl
    },
    // 提交表单
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          ssoHttp.post('/sso/oauth/login', {
            'backUrl': '',
            'loginType': 0,
            'useCaptcha': 1,
            'appCode': this.appCode,
            'username': this.dataForm.userName,
            'password': Crypto.encrypt(this.dataForm.password),
            'uuid': this.dataForm.uuid,
            'captcha': this.dataForm.captcha
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.redirectToLogin(data.authCode)
            } else {
              this.getCaptcha()
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    // 获取验证码JdbcAuthenticationRealm
    getCaptcha() {
      this.dataForm.uuid = getUUID()
      this.captchaPath = this.$http.adornUrl(contextPath + `/sso/captchaCode.png?uuid=${this.dataForm.uuid}`)
    }
  },
  watch: {
    lockActive(newVal) {
      if (!newVal) {
        this.CALogin()
      }
    }
  }
}
</script>


<style lang="scss">
html, body {
  height: 100%
}

@keyframes shangSheng {
  0% {
    opacity: 0;
    transform: translate(0, 0);
  }
  25% {
    opacity: 0;
    transform: translate(0, 30px);
  }
  50% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes douDong {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  80% {
    opacity: 1;
    transform: translate(0, 0);
  }
  85% {
    opacity: 1;
    transform: translate(0, 2px);
  }
  90% {
    opacity: 1;
    transform: translate(0, -2px);
  }
  95% {
    opacity: 1;
    transform: translate(0, 2px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes zhuan {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

ul, li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  /*background: url(../../assets/img/homebj.png) no-repeat 100% 100%;*/
  /*background-size: 100% 100%;*/
  /*<!--background: linear-gradient(-60deg, #174c95 0, #077ce0 100%);-->*/
  background-color: #102145;
  overflow: hidden;

  header {
    width: 100%;
    height: 140px;
    text-align: center;
    /*padding-top: 2%;*/
    position: absolute;
    left: 0;
    top: 0;

    .logo {
      margin-left: 2%;
      background: url(../../../../assets/img/hb-login/logo.png) no-repeat 50% 50%;
      width: 442px;
      height: 82px;
      z-index: 999;
      position: absolute;
      top: 20px;
      left: 2%;
    }
  }

  /*header p {*/
  /*    font-size: 30px;*/
  /*    font-family: Source Han Sans CN;*/
  /*    font-weight: bold;*/
  /*    color: #072130;*/
  /*    margin-left: 50px;*/
  /*}*/

  section {
    width: 900px;
    height: 500px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  .center {
    max-width: 1100px;
    min-width: 845px;
    max-height: 550px;
    min-height: 345px;
    width: 100%;
    /*height: 83%;*/
    display: flex;
    background: transparent;
    /*box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.3);*/

  }

  .centerLeft {
    background: rgba(9, 23, 54, 1);
    background-size: 81% auto;
    box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.3);
    width: 450px;
    height: 500px;
    position: relative;
    border-radius: 10px;

    .bg-box {
      animation: show 2s linear;
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/hb-login/bg.png) no-repeat 50% 50%
    }

    .shangsheng {
      animation: shangSheng 3s linear;

      .doudong {
        animation: douDong 3s linear;
      }
    }

    .bubble {
      width: 31px;
      height: 50px;
      background: url(../../../../assets/img/hb-login/升起.png) no-repeat 50% 50%;
      text-align: center;
      position: absolute;

      i {
        display: inline-block;
        width: 19px;
        height: 19px;
        margin-top: 6px;
      }
    }

    .logo1 {
      left: 52px;
      top: 49%;

      i {
        background: url(../../../../assets/img/hb-login/标1.png) no-repeat 50% 50%;
      }
    }

    .logo2 {
      right: 69px;
      top: 53.5%;

      i {
        background: url(../../../../assets/img/hb-login/标2.png) no-repeat 50% 50%;
      }
    }

    .logo3 {
      left: 80px;
      top: 12%;

      i {
        background: url(../../../../assets/img/hb-login/标3.png) no-repeat 50% 50%;
      }
    }

    .logo4 {
      right: 174px;
      top: 16%;

      i {
        background: url(../../../../assets/img/hb-login/标4.png) no-repeat 50% 50%;
      }
    }

    .logo5 {
      right: 124px;
      top: 23.5%;

      i {
        background: url(../../../../assets/img/hb-login/标5.png) no-repeat 50% 50%;
      }
    }

    .fly {
      left: 101px;
      top: 38%;
      width: 66px;
      height: 66px;
      border-radius: 50%;
      border: 1px solid #ffffff;
      position: absolute;
      text-align: center;
      transform: rotateX(-45deg);
      overflow: hidden;

      i {
        animation: zhuan .8s infinite linear;
        background: url(../../../../assets/img/hb-login/机翼.png) no-repeat 50% 50%;
        width: 100%;
        height: 100%;
        display: inline-block;
        border-radius: 50%;
        /*<!--background-image: url(../../assets/img/hb-login/机翼.png);-->*/
        /*<!--background-repeat: no-repeat;-->*/
        /*<!--background-position: -50% -50%;-->*/
      }
    }
  }

  .centerRight {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 99;
    width: 450px;
    height: 460px;
    box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.3);
    background: #fff;
    margin: 20px 0;
    padding: 20px;
    border-radius: 10px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;

    .caLock {
      padding: 0;
      position: relative;
      top: 10px;
      margin-top: 5px;

      .lockImg {
        text-align: center;
        border: 1px solid #cccccc;
        padding-bottom: 10px;

        img {
          width: 145px;
          margin-top: 10px;
          padding: 10px;
        }
      }
    }

    .login-box {
      width: 100%;
      height: 350px;

      .login-form {
        width: 100%;
        height: 100%;

        .el-form {
          width: 100%;
          height: 100%;

          .login-ul {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            li:nth-child(1) {
              height: 85px;
            }

            li:nth-child(2) {
              height: 85px;
            }

            li:nth-child(3) {
              height: 40px;
              margin-top: 30px;
            }

            .el-form-item {
              margin: 0;
            }

            .el-form-item.is-error {
              margin: 0;
            }

            .el-input__inner {
              padding-left: 30px;
            }
          }
        }
      }
    }
  }

  .centerRight p {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    line-height: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #3A3A3A;
    position: relative;
    bottom: 10px;
    text-indent: 10px;
  }

  .centerRight p span.spanActive {
    border-bottom: 2px solid rgba(23, 179, 163, 1);
  }

  .centerRight p span {
    padding-right: 10px;
    padding-bottom: 5px;
    cursor: pointer;
  }

  .centerRight /deep/ .login-form .el-form-item__label {
    color: #333333;
    font-size: 16px;
    padding-left: 10px;
    margin-top: 10px;
  }

  .centerRight /deep/ .login-form .el-form-item__label:before {
    display: none;
  }

  .centerRight button {
    width: 100%;
    height: 40px;
    background: rgba(23, 179, 163, 1);
    border-radius: 5px;
    border: 0;
    outline: 0;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
    margin-top: 20px;
  }

  .centerRight .blue-back {
    font-size: 16px;
    color: #666666;
    padding-left: 10px;
  }

  .login-li {
    position: relative;
  }

  .login-li > i {
    width: 21px;
    height: 24px;
    position: absolute;
    left: 5px;
    bottom: 8px;
    z-index: 1;
    background-size: auto 80%;
  }

  .login-user {
    background: url("../../../../assets/img/icon-user.png") no-repeat 50% 50%;
  }

  .login-pwd {
    background: url("../../../../assets/img/icon-pwd.png") no-repeat 50% 50%;
  }

  .forget .el-form-item__content,
  .forget .el-form-item__error {
    padding-left: 105px;
  }

  .btn-li .el-form-item__content {
    padding: 0;
  }

  .forget .el-form-item__label {
    width: 95px;
    padding: 0;
    margin: 0;
    text-align: right;
  }

  .forget /deep/ .message-btn {
    display: block;
    width: 120px;
    height: 36px;
    background: #3059FE;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
  }

  footer {
    width: 100%;
    height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;

    .foot-yuan {
      background: url(../../../../assets/img/hb-login/椭圆2.png) no-repeat 50% 50%;
      width: 1081px;
      height: 310px;
      position: absolute;
      right: -25%;
      bottom: 0;
    }
  }

  footer p {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
  }
}

</style>
